import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../context/AuthContext";
import "./UserDropdown.css";

const UserDropdown = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    logout();
    setOpen(false);
    navigate("/");
  };

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  /* ── NOT LOGGED IN ── */
  if (!user) {
    return (
      <button className="action-btn" onClick={() => navigate("/login")}>
        <PersonOutlineIcon className="action-btn-icon" />
        <span className="action-btn-label">Login / Signup</span>
        <span className="action-btn-sub">My Account</span>
      </button>
    );
  }

  /* ── LOGGED IN ── */
  const initials = user.name
    ? user.name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()
    : "U";

  return (
    <div className="ud-wrap" ref={wrapRef}>
      <button
        className="action-btn ud-trigger"
        onClick={() => setOpen((o) => !o)}
      >
        <div className="ud-avatar">
          {user.avatar ? (
            <img src={user.avatar} alt={user.name} className="ud-avatar-img" />
          ) : (
            <span className="ud-initials">{initials}</span>
          )}
        </div>
        <div className="ud-text-wrap">
          <span className="action-btn-label ud-name">{user.name}</span>
          <span className="action-btn-sub">My Account</span>
        </div>
        <KeyboardArrowDownIcon
          className={`ud-chevron${open ? " ud-chevron--open" : ""}`}
        />
      </button>

      {open && (
        <div className="ud-panel">
          {/* user chip */}
          <div className="ud-chip">
            <div className="ud-chip-avatar">
              {user.avatar ? (
                <img src={user.avatar} alt={user.name} />
              ) : (
                <span>{initials}</span>
              )}
            </div>
            <div className="ud-chip-info">
              <span className="ud-chip-name">{user.name}</span>
              <span className="ud-chip-email">{user.email}</span>
            </div>
          </div>

          <div className="ud-divider" />

          <button className="ud-item" onClick={() => go("/dashboard/profile")}>
            <PersonIcon className="ud-item-icon" />
            Profile
          </button>
          <button className="ud-item" onClick={() => go("/dashboard/orders")}>
            <ReceiptLongIcon className="ud-item-icon" />
            Order History
          </button>
          <button className="ud-item" onClick={() => go("/dashboard/settings")}>
            <SettingsIcon className="ud-item-icon" />
            Settings
          </button>

          <div className="ud-divider" />

          <button className="ud-item ud-item--logout" onClick={handleLogout}>
            <LogoutIcon className="ud-item-icon" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;